import React, { useEffect } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import { InvoicesTable } from '@app/components/apps/Finance/InvoiceListTable';

const AllInvoices: React.FC = () => {
  const { setBreadcrumb } = useHeader();
  const navigate = useNavigate();

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[
          {
            path: '/all-invoices',
            breadcrumbName: 'Invoices',
          },
        ]}
        style={{ marginBottom: '15px' }}
      />,
    );

    return () => {
      setBreadcrumb(undefined);
    };
  }, [setBreadcrumb, navigate]);

  return (
    <>
      <PageTitle>Invoices</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <InvoicesTable />
        </Col>
      </Row>
    </>
  );
};

export default AllInvoices;
